import { useState, useEffect } from 'react';

//Global hook only for develop
const listeners: any[] = [];
let state = false;

const setState = () => {
  state = !state;
  listeners.forEach((listener) => {
    listener(state);
  });
};

const useShowComingSoon = () => {
  const newListener = useState()[1];
  useEffect(() => {
    listeners.push(newListener);
  }, []);
  return [state, setState];
};

export default useShowComingSoon;
